import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { FormControl } from 'material-ui/Form';
import Input, { InputLabel } from 'material-ui/Input';
import { Image, Label } from 'semantic-ui-react';

import { ReduxFormField, ReduxFormFieldCheckPopup } from 'components';
import classNames from 'classnames/bind';
import styles from './ReduxFormCommon.css';
const cx = classNames.bind(styles);

class renderField extends PureComponent {
  componentDidMount() {
    const { input, defaultValue } = this.props;

    if (typeof defaultValue !== 'undefined' && (typeof input.value === 'undefined' || input.value === '')) {
      input.onChange(defaultValue);
    }
  }

  render() {
    const {
      required,
      input,
      meta,
      menuList,
      checkType,
      validate,
      warn,
      className,
      defaultValue,
      nonExistValue,
      noerror,
      label,
      native,
      name,
      errorText,
      ...rest
    } = this.props;

    if (!noerror && (meta.dirty || meta.touched) && meta.visited && meta.error) {
      rest.error = true;
    }

    const menuItem = [];
    var templateEnable = 0;
    if (Array.isArray(menuList)) {
      for (let i = 0; i < menuList.length; i++) {
        menuItem.push(
          native ? (
            <option key={menuList[i].key} value={menuList[i].value}>
              {menuList[i].text}
            </option>
          ) : (
              <MenuItem key={menuList[i].key} value={menuList[i].value}>
                {checkType === 102 && menuList[i].key !== 1 ? (
                  <Image className={cx('file-icon')} src={menuList[i].image} />
                ) : null}
                {menuList[i].text}
              </MenuItem>
            )
        );
        // if (menuList[i].value === input.value) {
        //   templateEnable = 1;
        // }
      }
      // if (!templateEnable) {
      //   menuItem.push(
      //     native ? (
      //       <option key={input.value} value={input.value}>
      //         {nonExistValue}
      //       </option>
      //     ) : (
      //       <MenuItem key={input.value} value={input.value}>
      //         {checkType === 102 && input.value !== 1 ? (
      //           <Image className={cx('file-icon')} />
      //         ) : null}
      //         {nonExistValue}
      //       </MenuItem>
      //     )
      //   );
      // }
    }

    return (
      <FormControl fullWidth className={className} error={rest.error || false}>
        {label && (
          <InputLabel error={rest.error || false} htmlFor={input.name} required={required || false}>
            {label}
          </InputLabel>
        )}
        <Select
          native={false}
          // input 전체를 전달하지 않고 아래 onChange 와 같이 필요한 이벤트 핸들러만 사용한다.
          // 이렇게 하면 불필요한 blur 이벤트 등이 발생하지 않아 처리가 간소해 지고
          // onChange 이벤트 내에서 setState 이용 시 pending 이 발생하지 않게 된다.
          // {...input}
          name={input.name}
          value={input.value}
          // redux-form 저장소 업데이트 위해 필요함,
          // 또한 이렇게 하지 않는 경우 value 값에 object 가 할당되므로 적절하게 맞춰야 하는 번거로움이 있음
          onChange={e => {
            input.onChange(e.target.value);
          }}
          onFocus={e => {
            input.onFocus();
          }}
          onBlur={e => {
            input.onBlur();
          }}
          input={<Input id={input.name} />}
          error={rest.error || false}
          className={rest.error ? 'validate-error' : ''}
          {...rest}>
          {menuItem}
        </Select>
        <div className={cx('dropdown-arrow')} />
        {rest.error ? (
          <Label className="pointing-label" basic pointing>
            {/* 훈련 실시에서 태그의 경우 에러 메세지와 name값이 달라서 errorMessage를 넘겨준다 */}
            {errorText ? errorText : meta.error}
          </Label>
        ) : null}
        {/* <ReduxFormFieldCheckPopup checkType={checkType} {...meta} /> */}
      </FormControl>
    );
  }
}

const ReduxFormMaterialSelect = ({ ...rest }) => {
  return <ReduxFormField component={renderField} {...rest} />;
};

ReduxFormMaterialSelect.propTypes = {
  checkType: PropTypes.number
};
ReduxFormMaterialSelect.defaultProps = {
  checkType: 99
};

export default ReduxFormMaterialSelect;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormMaterialSelect.js